// Iter122i · Scroll automatico all'inizio pagina ad ogni cambio di route.
// Su mobile è essenziale: senza questo, cambiando pagina si resta allo scroll
// della pagina precedente creando un'esperienza confusa.
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // "instant" per non innescare animazioni percepibili tra le pagine.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default ScrollToTop;
